"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _Image = _interopRequireDefault(require("../../Image"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Title = _interopRequireDefault(require("../../Title"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};
/* eslint-disable */


var Article = function Article(props) {
  var className = props.className,
      href = props.href,
      onCallbackHandle = props.onCallbackHandle,
      record = props.record,
      title = props.title,
      article = props.article,
      hrefText = props.hrefText,
      tabIndex = props.tabIndex,
      bindingNum = props.bindingNum,
      onTabClick = props.onTabClick,
      index = props.index;
  var tabFlag = tabIndex && bindingNum;

  var handleAClick = function handleAClick() {
    onTabClick && onTabClick(tabIndex, bindingNum);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article', className),
    "report-event": "click_areaCard_card",
    "report-ext1": index,
    "report-ext2": hrefText || '',
    "report-ext3": href || '',
    onClick: function onClick() {
      if (!href) return;

      if (tabIndex && bindingNum) {
        onTabClick && onTabClick(tabIndex, bindingNum);
        return;
      }

      window.location.href = href;
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article-container')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-default-article-container__section'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-article-container__section__div',
    onClick: function onClick() {
      onCallbackHandle && onCallbackHandle(record);
    }
  }, title && /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'wordBreak lineBreak'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('area-card-article-div-content'),
    dangerouslySetInnerHTML: {
      __html: article
    }
  }), tabFlag ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-default-article_a",
    onClick: handleAClick
  }, hrefText || "Learn more ", " >") : href ? /*#__PURE__*/_react["default"].createElement("a", {
    "report-event": "click_areaCard_href",
    "report-ext1": index,
    "report-ext2": hrefText || '',
    "report-ext3": href || '',
    className: 'flex-default-article_a',
    href: href
  }, hrefText || "Learn more ", " >") : null))));
};

var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      imageSrc = props.imageSrc,
      flexTitle = props.flexTitle,
      mergeComponentStatus = props.mergeComponentStatus,
      style = props.style,
      _a = props.imageLocation,
      imageLocation = _a === void 0 ? false : _a,
      configuration = props.configuration,
      className = props.className,
      onClick = props.onClick,
      onTabClick = props.onTabClick,
      restProps = __rest(props, ["banner", "sharp", "radius", "imageSrc", "flexTitle", "mergeComponentStatus", "style", "imageLocation", "configuration", "className", "onClick", "onTabClick"]);

  var len_cover = [2, 3, 5, 6].includes(configuration && configuration.length);
  var len = [3, 5, 6].includes(configuration && configuration.length);
  var len4 = [4, 7, 8].includes(configuration && configuration.length);
  var compatibleArr = configuration;

  if (len) {
    compatibleArr = configuration && configuration.length % 3 ? __spreadArrays(configuration, new Array(3 - configuration.length % 3).fill({
      supplement: true
    })) : configuration;
  } else if (len4) {
    compatibleArr = configuration && configuration.length % 4 ? __spreadArrays(configuration, new Array(4 - configuration.length % 4).fill({
      supplement: true
    })) : configuration;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-text-area-card-article-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-text-area-card-article-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    mergeComponentStatus: mergeComponentStatus,
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-default-area-card-revert'),
    ref: ref
  }, restProps), compatibleArr.map(function (item, index) {
    var source = item.source,
        content = item.content,
        title = item.title,
        href = item.href,
        hrefText = item.hrefText,
        supplement = item.supplement,
        _a = item.tabIndex,
        tabIndex = _a === void 0 ? null : _a,
        _b = item.bindingNum,
        bindingNum = _b === void 0 ? null : _b;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-default-area-card-revert-container-member', {
        'flex-default-area-card-revert-container-member-col3': len,
        'flex-default-area-card-revert-container-member-col4': len4,
        'flex-default-area-card-revert-container-member-col3--supplement': supplement
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      className: len ? 'img-circle-angle-default' : 'img-circle-angle',
      width: '564',
      height: '317',
      source: source,
      style: {
        height: 'auto',
        backgroundRepeat: '',
        // borderRadius: contentMaxHeight ? "inherit" : "7px",
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        borderBottomLeftRadius: !len_cover ? 0 : '4px',
        borderBottomRightRadius: !len_cover ? 0 : '4px'
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('', {
        'flex-default-area-card-article': !len,
        'flex-default-area-card-article-col3': len_cover,
        'flex-default-area-card-article-col4': len4
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-text-article-container', {
        'has-no-href': !href
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'img-container-default-article img-container-default-article__article'
    }, /*#__PURE__*/_react["default"].createElement(Article, {
      record: item || {},
      article: content,
      title: title,
      href: href,
      hrefText: hrefText,
      tabIndex: tabIndex,
      bindingNum: bindingNum,
      onTabClick: onTabClick,
      index: index
    })))));
  }))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = Thumbnail;
exports["default"] = _default;